








































































































































































































































import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { ExhibitorCategory, Exhibitor } from '@/models/exhibitor';
import { getPropertyFromItem, deepEqual, searchItems } from '@/utils/helpers';
import { orderBy, cloneDeep } from 'lodash';
import dateFormat from '@/utils/dateFormat';
export default Vue.extend({
  name: 'exhibitor-categories',
  metaInfo() {
    return {
      title: 'Exhibitor Categories'
    };
  },
  components: {
    draggable: () => import('vuedraggable')
  },
  data: () => ({
    selectedCategory: null as any,
    editCategory: null as any,
    nameRules: [(v: string) => !!v || 'Name is required'],
    searchQuery: '',
    editDialog: false,
    valid: true,
    editable: true,
    isDragging: false,
    delayedDragging: false,
    createDialog: false,
    draggedCategory: {} as ExhibitorCategory
  }),

  computed: {
    ...mapState('exhibitors', {
      exhibitors: 'exhibitors',
      categories: 'categories',
      exhibitorLoading: 'loading',
      exhibitorError: 'error'
    }),
    ...mapGetters('exhibitors', {
      getCategoryById: 'getCategoryById'
    }),
    orderedCategories(): ExhibitorCategory[] {
      return searchItems<ExhibitorCategory>(
        orderBy<ExhibitorCategory>(this.categories, ['id', 'name'], 'asc'),
        this.searchQuery
      );
    },
    computedPriority(): { value: number; display_name: string }[] {
      return [
        {
          value: 1,
          display_name: 'Tier 1'
        },
        {
          value: 2,
          display_name: 'Tier 2'
        },
        {
          value: 3,
          display_name: 'Tier 3'
        },
        {
          value: 4,
          display_name: 'Tier 4'
        },
        {
          value: 5,
          display_name: 'Tier 5'
        },
        {
          value: 6,
          display_name: 'Tier 6'
        },
        {
          value: 7,
          display_name: 'Tier 7'
        },
        {
          value: 8,
          display_name: 'Tier 8'
        }
      ];
    },
    dragOptions(): any {
      return {
        animation: 1,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      };
    }
  },

  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    editDialog(val: boolean) {
      // console.log(this.createDialog);

      if (val) {
        if (this.createDialog) {
          console.log('create true', this.createDialog);

          this.editCategory = {
            name: '',
            // priority: this.computedPriority[0].value,
            event: localStorage.getItem('current__event')
          };
        } else {
          console.log('create false', this.createDialog);

          this.editCategory = cloneDeep(this.selectedCategory);
        }
      } else {
        this.editCategory = null;
      }
    }
  },
  methods: {
    dateFormat,
    ...mapActions({
      fetchExhibitors: 'exhibitors/fetchExhibitors',
      createSponsor: 'exhibitors/createSponsor',
      fetchCategories: 'exhibitors/fetchCategories',
      deleteSponsor: 'exhibitors/deleteSponsor',
      updateCategory: 'exhibitors/updateCategory',
      deleteCategory: 'exhibitors/deleteCategory',
      createCategory: 'exhibitors/createCategory',
      createSnack: 'snackbar/createSnack'
    }),

    selectedCategoryExhibitors(id: number): Exhibitor[] | never[] {
      return (
        this.exhibitors.filter(
          (exhibitor: any | Exhibitor) => exhibitor.category?.id === id
        ) || []
      );
    },

    getText(item: object) {
      return getPropertyFromItem(item, 'name', item);
    },

    getValue(item: object) {
      return getPropertyFromItem(item, 'priority', this.getText(item));
    },

    findExistingIndex(item: object): number {
      const itemValue = this.getValue(item);
      // will find index of selected categories soon
      return (this.orderedCategories || []).findIndex((i: object) =>
        deepEqual(this.getValue(i), itemValue)
      );
    },

    selectCategory(id: number) {
      const category: ExhibitorCategory =
        this.getCategoryById(id) ||
        this.orderedCategories.find(
          (category: ExhibitorCategory) => category.id === id
        );
      // const i = this.findExistingIndex(category);
      const itemValue = this.getValue(category);

      deepEqual(this.getValue(this.selectedCategory), itemValue)
        ? (this.selectedCategory = null)
        : (this.selectedCategory = category);
    },
    async destryoyCategory(id: number) {
      const confirmDialog = this.$refs.confirmDialog as any;
      if (
        await confirmDialog.open('Delete Exhibitor Category?', {
          left: {
            text: 'Cancel'
          },
          right: {
            color: 'error',
            text: 'Delete',
            icon: 'mdi-delete',
            iconOnly: false
          }
        })
      ) {
        this.deleteCategory()
          .then(() => {
            this.createSnack({
              msg: 'Exhibitor Category Deleted',
              btnText: true
            });
          })
          .catch(() => {
            this.createSnack({
              msg: 'Failed to delete exhibitor category',
              color: 'error',
              btnText: true
            });
          });
      } else {
        return;
      }
    },
    saveCategory(category: Partial<ExhibitorCategory>) {
      if (this.validate()) {
        if (this.createDialog) {
          this.createCategory(category)
            .then(() => {
              this.reset();
              this.resetValidation();
              this.editDialog = false;
              this.createSnack({
                msg: 'Exhibitor Category Created',
                btnText: true
              });
            })
            .catch((err: any) => {
              console.log({ err });

              this.createSnack({
                msg: 'Failed to Create exhibitor Category',
                color: 'error',
                btnText: true
              });
            });
        } else {
          this.updateCategory(category)
            .then(() => {
              this.reset();
              this.resetValidation();
              this.editDialog = false;
              this.createSnack({
                msg: 'Exhibitor Category Updated',
                btnText: true
              });
            })
            .catch((err: any) => {
              console.log({ err });

              this.createSnack({
                msg: 'Failed to Update exhibitor Category',
                color: 'error',
                btnText: true
              });
            });
        }
      }
    },
    validate(): any {
      return (this as any).$refs.form.validate();
    },
    reset() {
      (this as any).$refs.form.reset();
    },
    resetValidation() {
      (this as any).$refs.form.resetValidation();
    },

    onMove(event: any) {
      const draggedElement = event.draggedContext.element;
      this.draggedCategory = draggedElement;
    },

    openDialog(flag = false) {
      this.createDialog = flag;

      this.$nextTick(() => {
        this.editDialog = true;
      });
    },

    updateList(event: any) {
      console.log('UPDATE LIST:', event);

      const categories: ExhibitorCategory[] = this.orderedCategories.map(
        function(category: ExhibitorCategory, index: number) {
          // task.status = currentState;
          // category.priority = index + 1;
          return category;
        }
      );
      // categories.forEach(task => this.updateCategory(task));
    },

    startList(val: any) {
      this.isDragging = true;
    }
  },
  mounted() {
    this.fetchExhibitors({
      event: localStorage.getItem('current__event')
    }).then(() => {
      this.fetchCategories({
        event: localStorage.getItem('current__event')
      }).then(res => {});
    });
  }
});
